import { v4 as uuid } from 'uuid';

interface SkeletonEntity {
  id: string;
}

export default function getSkeletonArray(size = 5): SkeletonEntity[] {
  return new Array(size).fill(null).map(() => ({ id: uuid() }));
}
